import { useState } from 'react';
import { useLocation } from 'react-router-dom';

// 2026-10-26 원픽 이전 안내 — 옛 공홈(sasohan.net)에 들어오면 탭당 1회 띄운다. 닫으면 계속 둘러볼 수 있다(강제 이동 없음).
// 「새 사이트로 이동」은 같은 경로로 보낸다 — 새 사이트가 옛 경로(/about·/ranking·/square/... 등)를 알아서 받는다.
const KEY = 'movedNotice20261026';

const MovedNotice = () => {
    const location = useLocation();
    const [open, setOpen] = useState(() => {
        try { return !sessionStorage.getItem(KEY); } catch (e) { return true; }
    });

    if (!open || location.pathname.startsWith('/app')) return null;

    const close = () => {
        try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
        setOpen(false);
    };
    const href = 'https://www.one-pick.net' + location.pathname + location.search;

    return (
        <div role="dialog" aria-modal="true" aria-labelledby="movedNoticeTit"
            style={{position:'fixed', inset:0, zIndex:2147483000, background:'rgba(0,0,0,.5)', display:'flex', alignItems:'center', justifyContent:'center', padding:16}}>
            <div style={{background:'#fff', borderRadius:14, maxWidth:360, width:'100%', padding:'28px 22px', textAlign:'center', boxSizing:'border-box'}}>
                <h2 id="movedNoticeTit" style={{fontSize:18, fontWeight:700, margin:'0 0 12px', color:'#222'}}>사이트가 새 주소로 이전되었습니다</h2>
                <p style={{fontSize:14, lineHeight:1.7, margin:0, color:'#555', wordBreak:'keep-all'}}>
                    원픽은 이제 <strong style={{color:'#222'}}>www.one-pick.net</strong> 에서<br/>이용하실 수 있습니다.
                </p>
                <div style={{display:'flex', gap:8, justifyContent:'center', marginTop:20}}>
                    <a href={href} style={{padding:'12px 18px', background:'#222', color:'#fff', borderRadius:8, textDecoration:'none', fontSize:14}}>새 사이트로 이동</a>
                    <button type="button" onClick={close} style={{padding:'12px 18px', background:'#eee', color:'#222', border:0, borderRadius:8, fontSize:14, cursor:'pointer'}}>닫기</button>
                </div>
            </div>
        </div>
    );
};

export default MovedNotice;
